import { ChangeDetectorRef, Component } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { FileService } from 'src/app/services/file.service';
import { AbstractWidgetInner } from 'src/app/widget-inner';
import { CustomChartView } from '../../widget/widget.component';

@Component({
  selector: 'app-chart-widget-inner',
  templateUrl: './chart-widget-inner.component.html',
  styleUrls: ['./chart-widget-inner.component.css']
})
export class ChartWidgetInnerComponent extends AbstractWidgetInner {

  showChart: boolean = false;
  public datasets: ChartDataSets[];
  public labels: Label[];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    maintainAspectRatio: false,
    annotation: { }
  };
  public lineChartLegend = true;
  public type;
  public lineChartPlugins = [];
  
  constructor(
    private _fileService: FileService,
    private _ref: ChangeDetectorRef
  ) {
    super();
  }

  receiveChartView(chart: CustomChartView){
    if(chart){
      this.currentChartView = chart;
      this._fileService.getJSONFileByPath(chart.href).subscribe((json: any) => {
        this.datasets = json.data.datasets;
        this.labels = json.data.labels;
        //this.options = json.options;
        this.type = json.type;
        this.showChart = true;
        this._ref.detectChanges();
      });
    } else {
      this.currentChartView = null;
      this.showChart = false;
    }
  }

}
